<template>
    <v-dialog v-model="show" max-width="1000">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="order" class="v-card--dialog v-card--dialog--sm">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">구매내역</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body">
                <v-data-table :items="order.purchases" :headers="purchaseHeaders" :loading="loading"  hide-default-footer disable-sort disable-pagination>
                    <template slot="item.no" slot-scope="{ item }">{{ order.purchases.indexOf(item) + 1 }}</template>
                    <template #[`item.product`]="{ item }">
                        <router-link :to="`/dshop/products/${item.product._mainProduct || item.product._id}`">
                            <span>{{ item?.product?.name }}</span>
                            <template v-if="(item?.product?.optionalNames || []).length">
                                <div v-for="(val, index) in item?.product?.optionalNames" :key="index">
                                    {{ `${val} : ${item?.product?.optionalValues[index]}` }}
                                </div>
                            </template>
                        </router-link>
                    </template>
                    <template #[`item.quantity`]="{ item }">{{ item.quantity }}개</template>
                </v-data-table>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import api from "@/api";
export default {
    props: {
        _order: { type: String, default: null },
    },
    data() {
        return {
            show: false,
            loading: false,

            order: {},
            purchaseHeaders: [
                { text: "No", value: "no", align: "center", width: "14%" },
                { text: "주문번호", value: "purchaseNo", align: "center" },
                { text: "상품", value: "product", align: "center" },
                { text: "수량", value: "quantity", align: "center" },
                { text: "상태", value: "status", align: "center" },
            ],
        };
    },
    methods: {
        async open() {
            try {
                if (this.loading) return;
                this.loading = true;

                let { order } = await api.v1.me.dshop.orders.get({ _id: this._order });
                this.order = order;
            } catch (error) {
                console.error(error);
                alert(error?.message);
            } finally {
                this.loading = false;
            }
        },

        close() {
            this.show = false;
            this.order = null;
        },

        setImgSrc(src) {
            // return `http://dev-giftcard.uxi.kr/${src}`;
            // return `https://dev-giftcard.uxi.kr/${src}`;
            return `https://daehanbooksgiftcard.com/${src}`;
        },
    },
    watch: {
        show() {
            if (this.show) this.open();
        },
    },
};
</script>